
import dayjs from "dayjs";

const {
    page_key,
    site,
    is_mobile_device
} = window.tg;

function is_touch_enabled() {
    return ( 'ontouchstart' in window ) ||
           ( navigator.maxTouchPoints > 0 ) ||
           ( navigator.msMaxTouchPoints > 0 );
}

export default () => {
    return {
        picker: null,
        minDate: dayjs().add(1, 'day').format('YYYY-MM-DD'),
        init() {
            // Minimum date is tomorrow or start date + 1 day
            this.minDate = this.$store.search.start != '' ? dayjs(this.$store.search.start).add(1, 'day').format('YYYY-MM-DD') : this.minDate

            const updated_search_form = document.querySelector('#search-form-updated');

            this.picker = window.flatpickr(this.$refs.end, {
                plugins: [new window.yearDropdownPlugin({
                    date: this.$store.search.end != '' ? window.dayjs(this.$store.search.end).format('YYYY-MM-DD') : '',
                    yearStart: 0,
                    yearEnd: 2
                })],
                position: "below",
                positionElement: updated_search_form && is_mobile_device ? document.querySelector('.end-date'): undefined,
                clickOpens: false,
                mode: 'single',
                dateFormat: 'Y-m-d',
                altInput: true,
                altFormat: 'j M Y',
                locale: {
                    firstDayOfWeek: 1
                },
                disableMobile: true,
                minDate: dayjs(this.minDate).toDate(),
                maxDate: site == 'vy' ? dayjs('2025-07-31').toDate() : dayjs().add(2, 'year').toDate(),
                defaultDate: this.$store.search.end != '' ? dayjs(this.$store.search.end).format('YYYY-MM-DD') : '',
                static: site === "vy" && !is_touch_enabled(),
                onValueUpdate: (date, dateString) => {

                    if (dateString != this.$store.search.end && dateString != '') {
                        this.$store.search.end = dayjs(dateString).format('YYYY-MM-DD')
                        this.$nextTick(() => this.$store.search.houseKeeping('start'))
                    }
                },
                onOpen: () => {
                    if (this.$store.search.total >= 3 && this.$store.search.end === '') {
                        let dismissCalendarElement = document.createElement('div');
                        dismissCalendarElement.className = 'alert w-100 text-primary font-size-sm px-3 py-2 d-flex justify-content-between align-items-center rounded-top';
                        dismissCalendarElement.style.backgroundColor = '#FDF0E6';
                        dismissCalendarElement.style.border = '1px solid #FBE4D6';
                        dismissCalendarElement.innerHTML = `
                            <div>
                                <i class="far fa-info-circle text-center text-primary mr-2"></i>
                                <span>${_t('kd.results.search_dates_required', 'Dates required to search')}</span>
                            </div>

                            <button class="close-btn">
                                <i class="fal fa-xmark text-primary text-center font-size-md" aria-label="Close"></i>
                            </button>
                        `;

                        const closeButtonElement = dismissCalendarElement.querySelector('.close-btn');
                        if (closeButtonElement) {
                            closeButtonElement.addEventListener('click', (event) => {
                                this.picker.close();
                            });
                        }

                        this.picker.calendarContainer.prepend(dismissCalendarElement);
                    }
                },
                onClose: () => {
                    this.picker.calendarContainer.querySelector('.alert')?.remove();

                    if (this.$store.search.end == '') {
                        this.picker.clear() // not using clear since sets date to []
                    }
                },
            })
            this.$watch('$store.search.end', (newEnd, oldEnd) => {
                if (oldEnd !== this.$store.search.end) {
                    let date = this.$store.search.end != '' ? dayjs(this.$store.search.end).format('YYYY-MM-DD') : ''
                    this.picker.setDate(date, true)
                }
            })
            this.$watch('$store.search.start', (newValue, oldValue) => this.update(oldValue, newValue))
            this.$watch('$store.search.activeSection', (newValue) => {
                // Don't allow the date picker to open on mobile when the search tray is closed
                if (is_mobile_device && page_key !== 'homepage' && this.$store.general.openSection !== 'SEARCH') return;

                // unsure when search form is teleported on desktop why two datepickers are opened even if $refs is undefined.
                if (newValue == 'end' && this.$refs.end !== undefined) this.picker.open()
            })
            this.$watch('$store.general.openSection', (newValue, oldValue) => {
                if (oldValue == 'SEARCH') this.picker.close()
            })
        },
        update(oldStartDate, newStartDate) {
            let newMinDate = this.$store.search.start != '' ? dayjs(this.$store.search.start).add(1, 'day') : dayjs().add(1, 'day')

            // Move length of stay to equal length of stay between start and end dates
            if (oldStartDate != ''
                && this.$store.search.end != ''
                && dayjs(this.$store.search.end).diff(dayjs(newMinDate), 'day') < 0) {

                let originalDayLength = dayjs(this.$store.search.end).diff(dayjs(oldStartDate), 'day') - 1
                this.picker.setDate(dayjs(newMinDate).add(originalDayLength, 'day').format('YYYY-MM-DD'))
            } else if (this.$store.search.end != '' && dayjs(this.$store.search.end).diff(dayjs(newMinDate), 'day') < 0) {
                this.$store.search.end = ''
                this.picker.clear()
            }

            // End date is minimum of start date + 1 day
            this.picker.set('minDate', dayjs(newMinDate).toDate())
        }
    }
}
